import React from "react";
import Animations from "../../utilities/Animations";
import ScrollService from "../../utilities/ScrollService";
import ScreenHeading from "../../utilities/ScreenHead/ScreenHeading";
import "./about.css";

export const About = (props) => {
  let fadeInScreenHand = (screen) => {
    if (screen.fadeInScreen !== props.id) return
    Animations.animations.fadeInscreen(props.id);
  };
  const fadeInSub = ScrollService.currScreenFadeIn.subscribe(fadeInScreenHand);

  const SCREEN_CONSTANT = {
    description:
      "Hello! 👋 My name is Gaurav Kumar, and I enjoy creating things that live on the internet. My interest in web development started last year when I was trying to edit stuff on the web — it taught me a lot about HTML & CSS!.",

    highlights: {
      bullets: [
        "Currently, I am learning Full-stack web development at Masai School, Bengaluru. Masai School is an outcome-driven school that believes in transforming education in India.",
        "I am skilled in React, Node.js, MongoDB, CSS, and HTML. I have a working knowledge of Java. I also developed some exciting web applications.",
      ],
      heading:"Here are some more highlight"
    },
    lastDesc:
      "One of my favourite things about developing web applications is the variety of projects. So if you want to collaborate or have some work for me, get in touch and tell me what you have in mind. — I can’t wait to hear all about it!",
  };

  const renderHighlight = () => {
    return SCREEN_CONSTANT.highlights.bullets.map((value, i) => (
      <div className="highlight" key={i}>
        <div className="highlightBlob"></div>
        <span>{value}</span>
      </div>
    ));
  };

  return (
    <div className="aboutContainer screeContainer" id={props.id || ""}>
      <div className="aboutParent">
        <ScreenHeading title={"About Me"} subHeading={"Why Choose Me ?"} />
        <div className="aboutCard">
          <div className="aboutProfile"></div>
          <div className="aboutDetail">
            <span className="aboutDesc">{SCREEN_CONSTANT.description}</span>
            <div className="aboutHigh">
              <div className="highHeading">
                <span>{SCREEN_CONSTANT.highlights.heading}</span>
              </div>
              {renderHighlight()}
            </div>
            <div className="aboutmore">
              <span className="aboutDesc">
                {SCREEN_CONSTANT.lastDesc}
              </span>
            </div>
            <div style={{textAlign:"center"}}>
              <a href="https://bit.ly/3tfGBzv" download="gaurav.pdf">
                <button className="btn higlighted-btn">Resume</button>
              </a>
            </div>
          </div>
        </div>
       
      </div>
    </div>
  );
};
